import { Component } from "react";
import ReactDOM from 'react-dom';
import {Chart} from 'chart.js';

class CustomChart extends Component {
    chartCanvas = null;
    chart = null;
  
    componentDidMount() {
      // console.log('CustomChart componentDidMount: ', this.props)
      this.configureChart();
    }

    componentDidUpdate() {
      if(this.chart) {this.chart.destroy();}
      // console.log('CustomChart componentDidUpdate: ', this.props)
      this.configureChart();
    }

    configureChart() {
      // console.log('CustomChart configureChart: ', this.props.data, this.props.options)
      let options = {}
      if(this.props.options!==null) {
        options = this.props.options
      }
      const chartCanvas = ReactDOM.findDOMNode(this.chartCanvas);
      this.chart = new Chart(chartCanvas, {
        type: "line",
        data: this.props.data,
        options: options,
      });
    };

    render() {
      return (
        <div>
          <canvas ref={canvas => { this.chartCanvas = canvas;}} />:
        </div>
      );
    }
}
export default CustomChart;